export default class LinkWrapper {
  static wrap(finder: any, linkTabIndex: number) {
    const links = finder.querySelectorAll('a');
    for (const link of links) {
      link.classList.add('link-wrapper');
      link.tabIndex = linkTabIndex;
    }
  }
}
